module.exports = __webpack_public_path__ + "img/expirenza.6fc529ce.png";